import { Router, Event } from '@angular/router';

declare let AOS: any;

import {Component, OnInit} from "@angular/core";

import {ViewManagerService} from "./services/view-manager.service";

import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "frc-www",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  title = "frc-www";

  constructor(
    private router: Router,
    public viewManager: ViewManagerService,
    private translate: TranslateService,
  ) {
    // this.router.events.subscribe((event: Event) => {
    //   console.log('[ROUTER EVENT]', event);
    // });
    this.translate.get('test.language').subscribe((res: string) => {
      console.log("admin component language in use:" + res);
    });
  }

  ngOnInit() {
    AOS.init();
    this.translate.addLangs(this.viewManager.getLanguages());
    this.translate.use(this.viewManager.getLanguage());
  }

}
